import React from 'react';
import prettyBytes from 'pretty-bytes';

interface FormatBandwidthProps {
  bytes: number;
}

const FormatBandwidth: React.FC<FormatBandwidthProps> = ({ bytes }) => (
  <span>{prettyBytes(bytes, { binary: true }).replace('iB', 'B')}</span>
);

export default FormatBandwidth;
